import axios from "axios";



export const getLidarFileNames = async (url, accessToken) => {
  const accessTokenValue = await accessToken();

  const response = await axios.post(
    process.env.REACT_APP_ADAPT_API + '/files/lidar/folderNames',
    {
      fullpath: url,
    },
    {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${accessTokenValue}`,
      }
    }
  );

  if (response.status !== 200) {
    throw new Error(`Error fetching data: ${response.statusText}`);
  }

  return response.data;
} 